var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonS3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1782 8.03732L25.0001 12.4514V21.5484L16 26.052L7 21.5484V12.4514L16 7.94775L16.1782 8.03732ZM16.4012 17.2464V24.9578L24.1977 21.0568V13.3454L16.4012 17.2464ZM15.5988 24.9578V17.2464L7.80236 13.3454V21.0568L15.5988 24.9578ZM8.29416 12.6979L16.0001 16.5532L23.706 12.6969L16.0001 8.84155L8.29416 12.6979Z",
    fill: "#F48B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonS3);
export default __webpack_public_path__ + "static/media/amazon_s3.e9c0f15c7ce4aafe1e5a38cd825b4818.svg";
export { ForwardRef as ReactComponent };